/**
 * External Dependencies
 */
import React from "react";

/**
 * Internal Dependencies
 */
import { OrderReceiveContextProvider } from "./context/order-receive-context";
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";

/**
 * Component
 */
class OrdersReceivePage extends React.Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <OrderReceiveContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </OrderReceiveContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default OrdersReceivePage;
